import { IconPlus } from '@iwoca/icons';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import StepItem from '../../../stepItem/StepItem';

export const AddNewAccount = () => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details_title"
                    defaultMessage="Add your business bank details"
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.add_new_funding_account_caption"
                    defaultMessage="For payout and direct debit"
                />
            }
            action={
                <Button variant="primary">
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.add_new_funding_account"
                        defaultMessage="Add now"
                    />
                    <IconPlus />
                </Button>
            }
        />
    );
};
